/**
 * PasswordRules component
 *
 * Displays the requirements for creating a valid password.
 * Lists the password criteria including character length,
 * case requirements, digit requirements, and special character requirements.
 *
 * Used as helper text in password input fields to guide users
 * in creating compliant passwords.
 *
 * @returns {JSX.Element} Box containing formatted password rules text
 */
const PasswordRules = () => (
  <>
    New password rules:
    <br />
    At least 8 characters long
    <br />
    At least one upper case letter
    <br />
    At least one lower case letter
    <br />
    At least one digit
    <br />
    At least one special character
  </>
);

export default PasswordRules;
